import React, { useState, useEffect } from "react";
import styled from "styled-components";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import {
  ButtonFilled,
  ButtonOutlined,
} from "../../reusableComponent/UIButtons";
import { Button, Form, message, Spin, Switch, Table, Checkbox } from "antd";
import UITable from "../../reusableComponent/UITable/UITable";
import { RightOutlined } from "@ant-design/icons";
import StyledClientWrapper from "./style";
import COLORS from "../../Common/Colors";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { setGetAllClientData } from "../../Redux/systemSlice";
import { useDispatch, useSelector } from "react-redux";
import { locationList } from "../../Common/Location";

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }
  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;
const AddClientWrap = styled.div`
  h6 {
    color: #636980;
  }
`;

const EditClient = ({ setAddNew }) => {
  const getAllClientData = useSelector(
    (state) => state.systemTracking.getAllClientData
  );
  const editClientData = useSelector(
    (state) => state.systemTracking.editClientData
  );

  const getUserInfo = localStorage.getItem("users");
  const userInfo = getUserInfo;
  const userDetails = JSON.parse(userInfo)
  const token = localStorage.getItem("token");
  const CheckboxOption = ["HR", "Pay"];

  const dataSource = [
    {
      key: 1,
      clientName: "Dashboard - Mine",
      name: "dashboard",
      access: editClientData?.dashboard,
      planType: "Basic",
    },
    {
      key: 2,
      clientName: "Check in and check out through Biometrics",
      name: "checkinout_biometric",
      access: editClientData?.checkinout_biometric,
      planType: "Basic",
    },
    {
      key: 3,
      clientName: "Leave application through portal",
      name: "leaveapplication_portal",
      access: editClientData?.leaveapplication_portal,
      planType: "Basic",
    },
    {
      key: 4,
      clientName: "Calendar view - Mine",
      name: "calender_view",
      access: editClientData?.calender_view,
      planType: "Basic",
    },
    {
      key: 5,
      clientName: "Calendar view - Team",
      name: "calender_view",
      access: editClientData?.calender_view,
      planType: "Basic",
    },
    {
      key: 6,
      clientName: "Calendar view - All",
      name: "calender_view",
      access: editClientData?.calender_view,
      planType: "Basic",
    },
    {
      key: 7,
      clientName: "Standard Reporting (Daily Attendance & Leave Report)",
      name: "standard_reporting",
      access: editClientData?.calender_view,
      planType: "Basic",
    },
    {
      key: 8,
      clientName: "Exception Reports - Late check-in ",
      name: "exception_report",
      access: editClientData?.exception_report,
      planType: "Basic",
    },
    {
      key: 9,
      clientName: "Exception Reports - Early Check out",
      name: "exception_report",
      access: editClientData?.exception_report,
      planType: "Basic",
    },
    {
      key: 10,
      clientName: "Exception Reports - Absent Report",
      name: "exception_report",
      access: editClientData?.exception_report,
      planType: "Basic",
    },
    {
      key: 11,
      clientName: "Support",
      name: "support",
      access: editClientData?.support,
      planType: "Basic",
    },
    {
      key: 12,
      clientName: "HR Resources - Policies",
      name: "hr_resources",
      access: editClientData?.hr_resources,
      planType: "Lite",
    },
    {
      key: 13,
      clientName: "HR Resources - People",
      name: "hr_resources",
      access: editClientData?.hr_resources,
      planType: "Lite",
    },
    {
      key: 14,
      clientName: "Manage",
      name: "manage",
      access: editClientData?.manage,
      planType: "Lite",
    },
    {
      key: 15,
      clientName: "Shift Management",
      name: "shift_management",
      access: editClientData?.shift_management,
      planType: "Lite",
    },

    {
      key: 16,
      clientName: "Document Management",
      name: "document_management",

      access: editClientData?.document_management,
      planType: "Lite",
    },
    {
      key: 17,
      clientName: "Dashboard - My Team",
      name: "dashboard",

      access: editClientData?.my_teams,
      planType: "Lite",
    },
    {
      key: 18,
      clientName: "Monthly Attendance Reports",
      name: "monthly_attandance_report",

      access: editClientData?.monthly_attandance_report,
      planType: "Lite",
    },
    {
      key: 19,
      clientName: "Asset Management",
      name: "asset_management",

      access: editClientData?.asset_management,
      planType: "Lite",
    },
    {
      key: 20,
      clientName: "Mobile App",
      name: "mobile_app",

      access: editClientData?.mobile_app,
      planType: "Lite",
    },
    {
      key: 21,
      clientName: "Recruitment Management",
      name: "recruitment_manaement",

      access: editClientData?.recruitment_manaement,
      planType: "Lite",
    },
    {
      key: 22,
      clientName: "Automated Onboarding",
      name: "automated_onboarding",

      access: editClientData?.automated_onboarding,
      planType: "Lite",
    },
    {
      key: 23,
      clientName: "Appraisal Management",
      name: "apprisal_management",

      access: editClientData?.apprisal_management,
      planType: "Lite",
    },
    {
      key: 24,
      clientName: "Dashboard - HR",
      name: "dashboard",
      access: editClientData?.dashboard_hr,
      planType: "Pro",
    },
    {
      key: 25,
      clientName: "Performance Management",
      name: "performance_management",

      access: editClientData?.performance_management,
      planType: "Pro",
    },
    {
      key: 26,
      clientName: "Travel/ Expense Approvals Management",
      name: "travel_expenses",

      access: editClientData?.travel_expenses,
      planType: "Pro",
    },

    {
      key: 27,
      clientName: "Expense Reimbursement",
      name: "expenses_reimbursment",

      access: editClientData?.expenses_reimbursment,
      planType: "Pro",
    },
    {
      key: 28,
      clientName: "Disciplinary Management",
      name: "disciplinary_management",

      access: editClientData?.disciplinary_management,
      planType: "Pro",
    },
    {
      key: 29,
      clientName: "Incident Reporting",
      name: "incident_reporting",
      access: editClientData?.incident_reporting,
      planType: "Pro",
    },
    {
      key: 30,
      clientName: "Simba AI",
      name: "simba_ai",
      access: editClientData?.simba_ai,
      planType: "Pro",
    },
    {
      key: 31,
      clientName: "Org Chart",
      name: "org_chart",
      access: editClientData?.org_chart,
      planType: "Pro",
    },
    {
      key: 32,
      clientName: "Activity Log",
      name: "activity_log",
      access: editClientData?.activity_log,
      planType: "Pro",
    },
    {
      key: 33,
      clientName: "Report Preferences",
      name: "report_preference",
      access: editClientData?.report_preference,
      planType: "Pro",
    },
    {
      key: 34,
      clientName: "Integration with existing Payroll system",
      name: "integrateex_payroll",
      access: editClientData?.integrateex_payroll,
      planType: "Pro",
    },
    {
      key: 35,
      clientName: "Payroll",
      name: "payroll",
      access: editClientData?.payroll,
      planType: "Pro",
    },
  ];

  const [countries, setCountries] = useState([]);

  const [step, setStep] = useState(1);
  const [data, setData] = useState(editClientData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [ispermission, setIsPermission] = useState(false);
  const [clientPermissionData, setClientPermissionData] = useState([]);
  const [menuList, setMenuList] = useState([]);

  useEffect(() => {
    setMenuList(data?.usermenulist);

    const systemData = Object.keys(data.products || {}).reduce(
      (acc, key) => {
        const keyMapping = {
          tymeplusHrStatus: "hr",
          tymeplusPayStatus: "pay",
        };
        if (data.products[key] === true && keyMapping[key]) {
          acc[keyMapping[key]] = true;
        }
        return acc;
      },
      {}
    );
    
    const system = Object.keys(systemData);

    setData((prev) => ({
      ...prev,
      system: system
    }));
  }, [editClientData]);
  console.log("menuList--->", menuList)
  console.log("data--->", data)
  // useEffect(() => {
  //   if (!data?.subscription_plan || !data?.products) return;

  //   setMenuList((prevMenuList) => {
  //     return prevMenuList?.map((item) => {
  //       let allowedPlans = [];

  //       // Check HR & Pay system selection
  //       const hasHR = data.products?.hr === true;
  //       const hasPay = data.products?.pay === true;
  //       const plan = data.subscription_plan.toLowerCase();

  //       // ✅ Function to determine allowed plans based on subscription level
  //       const getAllowedPlans = () => {
  //         if (plan === "basic") return ["Basic"];
  //         if (plan === "lite") return ["Basic", "Lite"];
  //         if (plan === "pro") return ["Basic", "Lite", "Pro"];
  //         return [];
  //       };

  //       allowedPlans = getAllowedPlans();

  //       // ✅ Check if the item belongs to HR or Pay
  //       const isHRSystem = item.system === "hr";
  //       const isPaySystem = item.system === "pay";

  //       // ✅ Allow only if HR or Pay is selected
  //       const isAllowedSystem = (hasHR && isHRSystem) || (hasPay && isPaySystem);

  //       // ✅ Final permission check → Only allow if `planType` is in `allowedPlans`
  //       const isAllowedPlan =
  //         isAllowedSystem &&
  //         (item.key !== "allapprovals"
  //           ? allowedPlans.includes(item?.planType)
  //           : true);

  //       // ✅ Update submenu access
  //       const updatedSubmenu = item?.subMenu?.map((subItem) => {
  //         const isTravelExpense = subItem?.key === "travelexpense";
  //         const isAllowed =
  //           plan === "basic" && isTravelExpense ? false : isAllowedPlan;

  //         return {
  //           ...subItem,
  //           access: isAllowed,
  //           permission: {
  //             create: isAllowed,
  //             edit: isAllowed,
  //             delete: isAllowed,
  //             view: isAllowed,
  //           },
  //         };
  //       }) || [];

  //       return {
  //         ...item,
  //         access: isAllowedPlan,
  //         subMenu: updatedSubmenu,
  //         permission: {
  //           create: isAllowedPlan,
  //           edit: isAllowedPlan,
  //           delete: isAllowedPlan,
  //           view: isAllowedPlan,
  //         },
  //       };
  //     });
  //   });
  // }, [data.subscription_plan, data.products]);

  // useEffect(() => {
  //   if (!data?.subscription_plan || !data?.products) return;

  //   setMenuList((prevMenuList) => {
  //     return prevMenuList?.map((item) => {
  //       let allowedPlans = [];

  //       // Extract product selections
  //       const hasHR = data.products?.hr === true;
  //       const hasPay = data.products?.pay === true;
  //       const plan = data.subscription_plan.toLowerCase();

  //       // ✅ Determine allowed plans based on subscription level
  //       if (plan === "basic") {
  //         allowedPlans = ["basic"];
  //       } else if (plan === "lite") {
  //         allowedPlans = ["basic", "lite"];
  //       } else if (plan === "pro") {
  //         allowedPlans = ["basic", "lite", "pro"];
  //       }

  //       // ✅ Ensure only relevant menus are updated
  //       const isHRSystem = item.system === "hr";
  //       const isPaySystem = item.system === "pay";
  //       const isHrandPaySystem = item.system === "hr" && item.system === "pay" && hasHR && hasPay
  //       const isAllowedSystem =
  //         (hasHR && isHRSystem) || (hasPay && isPaySystem) || (isHrandPaySystem);

  //       // ✅ Check if the item’s planType is allowed
  //       const isAllowedPlan =
  //         isAllowedSystem &&
  //         (item.key !== "allapprovals"
  //           ? allowedPlans.includes(item?.planType?.toLowerCase()) // ✅ Ensure correct case match
  //           : true);
  //       // const isAllowedPlan =
  //       //   item.key !== "allapprovals"
  //       //     ? allowedPlans?.includes((item?.planType || "").toLowerCase())
  //       //     : item;

  //       // ✅ Update submenu permissions
  //       const updatedSubmenu =
  //         item?.subMenu?.map((subItem) => {
  //           const isTravelExpense = subItem?.key === "travelexpense";
  //           const isAllowed =
  //             plan === "basic" && isTravelExpense ? false : isAllowedPlan;

  //           return {
  //             ...subItem,
  //             access: isAllowed,
  //             permission: {
  //               create: isAllowed,
  //               edit: isAllowed,
  //               delete: isAllowed,
  //               view: isAllowed,
  //             },
  //           };
  //         }) || [];

  //       return {
  //         ...item,
  //         access: isAllowedPlan,
  //         subMenu: updatedSubmenu,
  //         permission: {
  //           create: isAllowedPlan,
  //           edit: isAllowedPlan,
  //           delete: isAllowedPlan,
  //           view: isAllowedPlan,
  //         },
  //       };
  //     });
  //   });
  // }, [data.subscription_plan, data.products, data]);

  // useEffect(() => {
  //   if (!data?.subscription_plan || !data?.products) return;

  //   setMenuList((prevMenuList) => {
  //     return prevMenuList?.map((item) => {
  //       let allowedPlans = [];

  //       // Convert subscription plan to lowercase once for efficiency
  //       const plan = data.subscription_plan.toLowerCase();

  //       // Determine allowed plans based on the subscription level
  //       if (plan === "basic") {
  //         allowedPlans = ["basic"];
  //       } else if (plan === "lite") {
  //         allowedPlans = ["basic", "lite"];
  //       } else if (plan === "pro") {
  //         allowedPlans = ["basic", "lite", "pro"];
  //       }

  //       const isHRSystem = item.system === "hr";
  //       const isPaySystem = item.system === "pay";

  //       const hasHR = data.products?.tymeplusHrStatus === true;
  //       const hasPay = data.products?.tymeplusPayStatus === true;
  //       const isAllowedSystem =
  //         (hasHR && isHRSystem) || (hasPay && isPaySystem) || (hasHR && hasPay);

  //       // Check if the item's planType matches any allowed plans
  //       const isAllowedPlan =
  //         isAllowedSystem &&
  //         (item.key !== "allapprovals"
  //           ? allowedPlans.includes(item.planType?.toLowerCase())
  //           : true);

  //       // Update submenu permissions
  //       const updatedSubmenu =
  //         item?.subMenu?.map((subItem) => {
  //           const isTravelExpense = subItem?.key === "travelexpense";
  //           const isAllowed =
  //             plan === "basic" && isTravelExpense ? false : isAllowedPlan;

  //           return {
  //             ...subItem,
  //             access: isAllowed,
  //             permission: {
  //               create: isAllowed,
  //               edit: isAllowed,
  //               delete: isAllowed,
  //               view: isAllowed,
  //             },
  //           };
  //         }) || [];

  //       return {
  //         ...item,
  //         access: isAllowedPlan,
  //         subMenu: updatedSubmenu,
  //         permission: {
  //           create: isAllowedPlan,
  //           edit: isAllowedPlan,
  //           delete: isAllowedPlan,
  //           view: isAllowedPlan,
  //         },
  //       };
  //     });
  //   });
  // }, [data.subscription_plan, data.products, data]);
  // useEffect(() => {
  //   if (!data?.subscription_plan || !data?.products || !data?.usermenulist) return;
  
  //   setMenuList((prevMenuList) => {
  //     return prevMenuList?.map((item) => {
  //       let allowedPlans = [];
  //       const plan = data.subscription_plan.toLowerCase();
  
  //       if (plan === "basic") {
  //         allowedPlans = ["basic"];
  //       } else if (plan === "lite") {
  //         allowedPlans = ["basic", "lite"];
  //       } else if (plan === "pro") {
  //         allowedPlans = ["basic", "lite", "pro"];
  //       }
  
  //       const isHRSystem = item.system === "hr";
  //       const isPaySystem = item.system === "pay";
  //       const hasHR = data.products?.tymeplusHrStatus === true;
  //       const hasPay = data.products?.tymeplusPayStatus === true;
  //       const isAllowedSystem =
  //         (hasHR && isHRSystem) || (hasPay && isPaySystem) || (hasHR && hasPay);
  
  //       const isAllowedPlan =
  //         isAllowedSystem &&
  //         (item.key !== "allapprovals"
  //           ? allowedPlans.includes(item.planType?.toLowerCase())
  //           : true);
  
  //       // Find the corresponding user menu item from `data.usermenulist`
  //       const userMenuItem = data.usermenulist.find((userItem) => userItem.key === item.key);
            
  //       const updatedSubmenu =
  //         item?.subMenu?.map((subItem) => {
  //           const userSubItem = userMenuItem?.subMenu?.find(
  //             (userSub) => userSub.key === subItem.key
  //           );
  //           const isTravelExpense = subItem?.key === "travelexpense";
  //           const isAllowed =
  //             plan === "basic" && isTravelExpense ? false : isAllowedPlan;
  
  //           return {
  //             ...subItem,
  //             access: userSubItem?.access === false ? false : isAllowed,
  //             permission: {
  //               create: userSubItem?.permission?.create === false ? false : isAllowed,
  //               edit: userSubItem?.permission?.edit === false ? false : isAllowed,
  //               delete: userSubItem?.permission?.delete === false ? false : isAllowed,
  //               view: userSubItem?.permission?.view === false ? false : isAllowed,
  //             },
  //           };
  //         }) || [];
  
  //       return {
  //         ...item,
  //         access: userMenuItem?.access === false ? false : isAllowedPlan,
  //         subMenu: updatedSubmenu,
  //         permission: {
  //           create: userMenuItem?.permission?.create === false ? false : isAllowedPlan,
  //           edit: userMenuItem?.permission?.edit === false ? false : isAllowedPlan,
  //           delete: userMenuItem?.permission?.delete === false ? false : isAllowedPlan,
  //           view: userMenuItem?.permission?.view === false ? false : isAllowedPlan,
  //         },
  //       };
  //     });
  //   });
  // }, [data.subscription_plan, data.products, data.usermenulist]);  

  useEffect(() => {
    setMenuList((prevMenuList) => {
      const currentPlan = data?.subscription_plan?.toLowerCase();
      
      // First create a map of existing menu settings for quick lookup
      const existingMenuMap = {};
      data?.usermenulist?.forEach(menu => {
        existingMenuMap[menu.key] = menu;
      });

      return prevMenuList?.map((item) => {
        // Get existing settings if available
        const existingMenu = existingMenuMap[item.key];
        
        // Determine allowed plans based on current subscription
        const allowedPlans = [];
        if (currentPlan === "basic") allowedPlans.push("basic");
        if (currentPlan === "lite") allowedPlans.push("basic", "lite");
        if (currentPlan === "pro") allowedPlans.push("basic", "lite", "pro");

        // System access check
        const hasHR = data?.system?.includes("hr");
        const hasPay = data?.system?.includes("pay");
        const isHRSystem = item.system === "hr";
        const isPaySystem = item.system === "pay";
        const isAllowedSystem = (hasHR && isHRSystem) || (hasPay && isPaySystem);

        // Check if item matches current plan
        const isAllowedPlan = allowedPlans.includes(item?.planType?.toLowerCase());
        
        // Special case - always allow allapprovals
        const isAllApprovals = item.key === "allapprovals";

        // Start with existing access if it exists
        let updatedAccess = existingMenu?.access ?? false;
        
        // Override access if:
        // 1. Item matches current plan AND is in allowed system
        // 2. Or it's the allapprovals menu
        if ((isAllowedSystem && isAllowedPlan) || isAllApprovals) {
          updatedAccess = true;
        }

        // Handle submenus
        const updatedSubmenu = item?.subMenu?.map(subItem => {
          const existingSubmenu = existingMenu?.subMenu?.find(sub => sub.key === subItem.key);
          const isSubAllowedPlan = allowedPlans.includes(subItem?.planType?.toLowerCase());
          
          let subAccess = existingSubmenu?.access ?? false;
          if (isAllowedSystem && isSubAllowedPlan) {
            subAccess = true;
          }
          
          return {
            ...subItem,
            access: subAccess,
            permission: existingSubmenu?.permission || {
              create: subAccess,
              edit: subAccess,
              delete: subAccess,
              view: subAccess,
            }
          };
        }) || [];

        return {
          ...item,
          access: updatedAccess,
          subMenu: updatedSubmenu,
          permission: existingMenu?.permission || {
            create: updatedAccess,
            edit: updatedAccess,
            delete: updatedAccess,
            view: updatedAccess,
          }
        };
      });
    });
  }, [data?.subscription_plan, data?.system, data?.usermenulist]);
  
  
  const handleCheckboxChange = (item, checked) => {
    setClientPermissionData((prevData) =>
      prevData?.map((data) =>
        data.key === item.key ? { ...data, access: checked } : data
      )
    );
  };

  // const handledCheckboxChange = (checked, menu, submenu) => {
  //   setMenuList((prevMenuList) => {
  //     const updatedList = prevMenuList?.map((item) => {
  //       if (item?.id === menu) {
  //         if (submenu?.length > 0) {
  //           const updatedSubmenu = item?.subMenu?.map((subItem) => {
  //             if (subItem?.key === submenu) {
  //               return {
  //                 ...subItem,
  //                 permission: {
  //                   create: checked,
  //                   view: checked,
  //                   delete: checked,
  //                   edit: checked,
  //                 },
  //                 access: checked,
  //               };
  //             }
  //             return subItem;
  //           });
  //           const allSubMenuAccessFalse =
  //             updatedSubmenu?.length > 0 &&
  //             updatedSubmenu?.every((subItem) => subItem?.access === false);
  //           return {
  //             ...item,
  //             access: allSubMenuAccessFalse ? false : true,
  //             subMenu: updatedSubmenu,
  //           };
  //         } else {
  //           return {
  //             ...item,
  //             access: checked,
  //             permission: {
  //               create: checked,
  //               view: checked,
  //               delete: checked,
  //               edit: checked,
  //             },
  //           };
  //         }
  //       }

  //       return item;
  //     });
  //     return updatedList;
  //   });
  // };

  const handledCheckboxChange = (checked, menuId, submenuId) => {
    setMenuList((prevMenuList) =>
      prevMenuList.map((item) => {
        if (item.id === menuId) {
          // ✅ Prevent updating state if the item is disabled
          if (
            (data.subscription_plan === "basic" && item.planType !== "Basic") ||
            (data.subscription_plan === "lite" && item.planType === "Pro")
          ) {
            return item; // 🔥 Do not update state
          }
  
          if (!submenuId) {
            return { ...item, access: checked };
          }
  
          return {
            ...item,
            subMenu: item.subMenu.map((sub) =>
              sub.id === submenuId ? { ...sub, access: checked } : sub
            ),
          };
        }
        return item;
      })
    );
  };

  const renderPlanBox = (planType, menu) => (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "20px",
        marginBottom: "20px",
        backgroundColor: "#f9f9f9",
        flex: "1",
      }}
    >
      <h3 style={{ textAlign: "center", color: "#333", marginBottom: "20px" }}>
        {planType} Plan
      </h3>
      {menu?.map((item) => (
        <div key={item.key} style={{ marginBottom: "10px" }}>
          {item?.subMenu?.length === 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>{item?.menuName}</span>
              <Checkbox
                name={item.name}
                checked={item?.access}
                style={{ width: "30px" }}
                
                disabled={
                  (data.subscription_plan === "basic" && item.planType !== "Basic") || // Disable Lite & Pro if Basic is selected
                  (data.subscription_plan === "lite" && item.planType === "Pro") // Disable Pro if Lite is selected
                }
                // onChange={(e) =>
                //   handledCheckboxChange(e.target.checked, item.id, "")
                // }
                onChange={(e) => {
                  // Prevent changes when the checkbox should be read-only
                  if (
                    (data.subscription_plan === "basic" && item.planType !== "Basic") || 
                    (data.subscription_plan === "lite" && item.planType === "Pro")
                  ) {
                    return; // Do nothing, making it read-only
                  }
                  handledCheckboxChange(e.target.checked, item.id, item.key);
                }} 
              />
            </div>
          )}
          {item?.subMenu?.length > 0 && (
            <>
              {item?.subMenu
                ?.filter((item) => item?.planType === planType)
                ?.map((val) => (
                  <div key={item.key} style={{ marginBottom: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>{val?.menuName}</span>
                      <Checkbox
                        name={val.name}
                        style={{ width: "30px" }}
                        checked={val?.access}
                        disabled={
                          (data.subscription_plan === "basic" && val.planType !== "Basic") || // Disable Lite & Pro if Basic is selected
                          (data.subscription_plan === "lite" && val.planType === "Pro") // Disable Pro if Lite is selected
                        }
                        // onChange={(e) =>
                        //   handledCheckboxChange(
                        //     e.target.checked,
                        //     item.id,
                        //     val.key
                        //   )
                        // }
                        onChange={(e) => {
                          // Prevent changes when the checkbox should be read-only
                          if (
                            (data.subscription_plan === "basic" && val.planType !== "Basic") || // Disable Lite & Pro if Basic is selected
                            (data.subscription_plan === "lite" && val.planType === "Pro") // Disable Pro 
                          ) {
                            return; // Do nothing, making it read-only
                          }
                          handledCheckboxChange(e.target.checked, val.id, val.key);
                        }}
                      />
                    </div>
                  </div>
                ))}
            </>
          )}
        </div>
      ))}
    </div>
  );
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const tabledata = [
    {
      id: 1,
      featurename: "Dashboard(Mine, My Team, HR)",
      // pricing: "-",
      subscription: "Basic | Lite | Pro",
    },
    {
      id: 2,
      featurename: "Check in and Check out through Biometrics",
      // pricing: "-",
      subscription: "Lite | Pro",
    },
    {
      id: 3,
      featurename: "Leave application through portal",
      // pricing: "-",
      subscription: "Lite",
    },
  ];

  const ActionButtonStyle = {
    cancelButton: {
      color: "#2D53DA !important",
      border: "1px solid #2D53DA",
      width: "130px",
      height: "34px",
      padding: "6.5px",
      borderRadius: "8px",
      background: "unset !important", // !important is not supported here
    },
    NextButton: {
      border: "1px solid #2D53DA",
      width: "130px",
      height: "34px",
      padding: "6.5px",
      borderRadius: "8px",
      color: "#fff !important",
    },
  };

  const columns = [
    {
      title: "Feature name",
      dataIndex: "featurename",
      key: "featurename",
      width: "25%",
    },
    // {
    //   title: "Pricing",
    //   dataIndex: "pricing",
    //   key: "pricing",
    //   width: "25%",
    // },
    // {
    //   title: "Available in Subscription Model",
    //   dataIndex: "subscription",
    //   key: "subscription",
    //   width: "25%",
    // },
    {
      title: "Access",
      dataIndex: "action",
      key: "action",
      width: "25%",
      render: (action, record) => {
        return (
          <Switch
            className="switch_button"
            defaultChecked
            name={record.clientName}
            size="small"
            checked={record.access}
            onChange={(checked) => handleSwitchChange(record, checked)}
          />
        );
      },
    },
  ];

  const handleSubmitForm = async (e) => {
    try {
      await form.validateFields();
      setStep(2);
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const handleClickCancel = () => {
    navigate("/client");
  };

  const SubcriptionPlanData = [
    { value: "basic", label: "Basic" },
    { value: "lite", label: "Lite" },
    { value: "pro", label: "Pro" },
  ];

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("https://restcountries.com/v3.1/all");
        const countryOptions = response.data?.map((country) => ({
          label: country.name.common, // Display name
          value: country.name.common, // Country code as value
        }));
        setCountries(countryOptions);
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };

    fetchCountries();
  }, []);

  const addNewClientForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [],
        fields: [
          [
            {
              id: 1,
              label: "Company Name:",
              type: "text",
              name: "company_name",
              Placeholder: "",
              maxLength: 50,
              onKeyDown: /^[a-zA-Z\s]+$/,
              validationRules: [
                { required: true, message: "Company name is required" },
                {
                  min: 0,
                  max: 50,
                  // message: "Company name must be between 3 and 25 characters",
                },
                // {
                //   pattern: /^[a-zA-Z\s]*$/,
                //   message:
                //     "Company name cannot contain numbers or special characters",
                // },
              ],
            },
            {
              id: 2,
              label: "Client Name:",
              type: "text",
              name: "client_name",
              Placeholder: "",
              maxLength: 50,
              onKeyDown: /^[a-zA-Z\s]+$/,
              validationRules: [
                { required: true, message: "Client name is required" },
                {
                  min: 0,
                  max: 50,
                  //message: "Client name must be between 3 and 25 characters",
                },
                {
                  pattern: /^[a-zA-Z\s]*$/,
                  // message:
                  //   "Client name cannot contain numbers or special characters",
                },
              ],
              onInput: (e) => {
                e.target.value = e.target.value.replace(/[0-9]/g, "");
              },
            },
          ],
          [
            {
              id: 3,
              label: "Location:",
              type: "select",
              name: "location",
              // options: countries,
              options: locationList,
              Placeholder: "",
              validationRules: [
                { required: true, message: "Location is required" },
              ],
            },
            {
              id: 4,
              label: "Employee Count / Company Size:",
              type: "text",
              name: "employee_count",
              maxLength: 4,
              Placeholder: "",
              onKeyDown: /^[0-9]$/,
              validationRules: [
                { required: true, message: "Employee Count is required" },
                {
                  // pattern: /^[0-9]{1,4}$/,
                  // message:
                  //   "Employee Count must be a number less than or equal to 4 characters",
                },
              ],
            },
          ],
          [
            {
              id: 5,
              label: "Contact Person:",
              type: "text",
              name: "contact_person",
              onKeyDown: /^[a-zA-Z\s]+$/,
              Placeholder: "",
              maxLength: 30,
              validationRules: [
                {
                  required: true,
                  message: "Contact Person is required",
                },
                {
                  min: 0,
                  max: 30,
                  // message: "Contact Person must be between 3 and 30 characters",
                },
                {
                  pattern: /^[a-zA-Z\s]*$/,
                  // message:
                  //   "Contact Person cannot contain numbers or special characters",
                },
              ],
            },
            {
              id: 6,
              label: "Contact Number:",
              type: "phone",
              name: "contact_number",
              maxLength: 20,
              Placeholder: "",
              validationRules: [
                { required: true, message: "Contact Number is required" },
                {
                  min: 0,
                  max: 20,
                },
                {
                  pattern: /^[0-9]{10,20}$/,
                  message: " ",
                },
              ],
              validateTrigger: "onBlur",
            },
          ],
          [
            {
              id: 7,
              label: "Email ID:",
              type: "email",
              name: "email_id",
              disabled: true,
              Placeholder: "",
              validationRules: [
                { required: true, message: "email is required" },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
              ],
            },
            {
              id: 13,
              label: "Status:",
              type: "select",
              name: "status",
              options: [
                { label: "Active", value: "active" },
                { label: "Inactive", value: "inactive" },
              ],
              Placeholder: "",
              validationRules: [
                { required: true, message: "Status is required" },
              ],
            },
            // {
            //   id: 13,
            //   label: "System:",
            //   type: "checkboxgroup",
            //   name: "system",
            //   options: CheckboxOption,
            //   Placeholder: "System Status",
            //   validationRules: [
            //     { required: true, message: "System is required" },
            //   ],
            // },
            // {
            //   id: 14,
            //   label: "Attach Client Contract:",
            //   type: "file",
            //   name: "client_contract_file",
            //   Placeholder: "",
            // },
          ],
          [
            {
              id: 9,
              label: "Subscription Plan:",
              type: "select",
              name: "subscription_plan",
              options: SubcriptionPlanData,
              Placeholder: "",
              validationRules: [
                { required: true, message: "Subscription Plan is required" },
              ],
            },
            {
              id: 10,
              label: "Subscription Frequency:",
              type: "select",
              name: "supscription_frequency",
              options: [
                { label: "Bi-annually", value: "biannually" },
                { label: "Quaterly", value: "quaterly" },
                { label: "Monthly", value: "monthly" },
                { label: "Yearly", value: "yearly" },
              ],
              Placeholder: "",
              validationRules: [
                {
                  required: true,
                  message: "Subscription Frequency is required",
                },
              ],
            },
          ],
          [
            {
              id: 9,
              label: "Subscription Start Date:",
              type: "date",
              name: "subscription_start_date",
              Placeholder: "",
              // maxLength: 50,
              // onKeyDown: /^[a-zA-Z\s]+$/,
              validationRules: [
                {
                  required: true,
                  message: "Subscription Start Date is required",
                },
              ],
            },
            {
              id: 12,
              label: "Subscriber Count:",
              type: "text",
              name: "subscriber_count",
              Placeholder: "",
              onKeyDown: /^[0-9]$/,
            },
          ],
          [
            {
              id: 8,
              label: "Amount ($):",
              type: "text",
              name: "amount",
              maxLength: 10,
              onKeyDown: /^[0-9]$/,
              Placeholder: "",
              validationRules: [
                { required: true, message: "Amount is required" },
                {
                  min: 0,
                  max: 10,
                },
                {
                  pattern: /^[0-9]{1,10}$/,
                  message:
                    "Amount must be a number less than or equal to 10 characters",
                },
              ],
            },
            {
              id: 11,
              label: "Discount:",
              type: "text",
              name: "discount",
              Placeholder: "",
              onKeyDown: /^[0-9]$/,
            },
          ],

          [
            {
              id: 14,
              label: "System Purchasing:",
              type: "select",
              name: "system",
              multipleSelect: "multiple",
              options: [
                { label: "HR", value: "hr" },
                { label: "Pay", value: "pay" },
              ],
              Placeholder: "Select System",
              validationRules: [
                { required: true, message: "System is required" },
              ],
            },
            {
              id: 15,
              label: "Default Product:",
              type: "select",
              name: "defaultproduct",
              // disabled: Array.isArray(data?.product) && data.product.includes("hr") && data.product.includes("pay") ? false : true,
              options: (() => {
                if (!Array.isArray(data?.system)) return [];
            
                if (data.system.includes("hr") && data.system.includes("pay")) {
                  return [
                    { label: "TymeplusHR", value: "1" },
                    { label: "Tymeplus Pay", value: "2" },
                  ];
                } else if (data.system.includes("hr")) {
                  return [{ label: "TymeplusHR", value: "1" }];
                } else if (data.system.includes("pay")) {
                  return [{ label: "Tymeplus Pay", value: "2" }];
                }
            
                return [];
              })(),
              // options: [
              //   { label: "TymeplusHR", value: "1" },
              //   { label: "Tymeplus pay", value: "2" },
              // ],
              Placeholder: "Select default product",
              validationRules: [
                { required: true, message: "Default product is required" },
              ],
            },
          ],
        ],
      },
    ],
  };

  // const stepdata = [
  //   { id: 1, title: "Basic" },
  //   { id: 2, title: "Feautures" },
  // ];

  const handleFormChange = (e) => {
    console.log("e--->", e)
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (selectedValues, name) => {
    // form.setFieldsValue({ [name]: selectedValues });
    console.log("selectedValues--->",name, selectedValues)
    if (name === "system") {
      let defaultProductData = "";

      if (selectedValues.includes("hr") && selectedValues.includes("pay")) {
        defaultProductData = "1"; // If both are present, set to "1"
      } else if (selectedValues.includes("hr")) {
        defaultProductData = "1"; // If only HR is present, set to "1"
      } else if (selectedValues.includes("pay")) {
        defaultProductData = "2"; // If only Pay is present, set to "2"
      }

      setData((prev) => ({
        ...prev,
        [name]: selectedValues,
        products: {
          ...prev.products,
          tymeplusHrStatus: selectedValues.includes("hr") ? true : false,
          tymeplusPayStatus: selectedValues.includes("pay") ? true : false,
        },
        defaultproduct: defaultProductData
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [name]: selectedValues,
      }));
    }
  };

  const handleSwitchChange = (record, checked) => {
    setClientPermissionData((prevData) => {
      const updatedData = prevData?.map((item) =>
        item.key === record.key ? { ...item, access: checked } : item
      );
      return updatedData;
    });
    setData({
      ...data,
      [record.name]: checked,
    });
  };

  const handlesubmit = async () => {
    try {
      const userauthregisterurl =
        // "https://peo32t8k2i.execute-api.ap-south-1.amazonaws.com/dev/user/menulist";
        "https://peo32t8k2i.execute-api.ap-south-1.amazonaws.com/dev/user/update";

        const systemData = {
          tymeplusHrStatus: data?.products?.tymeplusHrStatus ? true : false,
          tymeplusPayStatus: data?.products?.tymeplusPayStatus ? true : false,
        };
      const updatedValues = systemData || editClientData?.products || {};
      // const payload = {
      //   companyName: data?.company_name || editClientData?.company_name,
      //   country: "",
      //   domain: "",
      //   email: data?.email_id || editClientData?.email_id,
      //   defaultProduct: data?.defaultProduct || editClientData?.defaultProduct,
      //   employeeCount: data?.employee_count || editClientData?.employee_count,
      //   firstName: data?.client_name || editClientData?.client_name,
      //   interval: "",
      //   lastName: "",
      //   monthlyCost: 0,
      //   paymentType: "free",
      //   productList: "",
      //   totalCost: 0,
      //   type: "company",
      //   subscription_plan:
      //     data?.subscription_plan || editClientData?.subscription_plan,
      //   subscription_start_date:
      //     data?.subscription_start_date ||
      //     editClientData?.subscription_start_date ||
      //     "",
      //   phoneNumber: data?.contact_number || editClientData?.contact_number,
      //   usermenuList: menuList,
      //   clientId: editClientData?.clientid,
      //   products: updatedValues,
      // };
      // const systemData = {
      //   tymeplusHrStatus: data?.products?.tymeplusHrStatus ? true : false,
      //   tymeplusPayStatus: data?.products?.tymeplusPayStatus ? true : false,
      // };
      // const payload = {
      //   clientId: data?.clientid,
      //   subscription_plan:
      //     data?.subscription_plan || editClientData?.subscription_plan,
      //   usermenuList: menuList,
      // };
      const Payload = {
        "clientId": data?.clientid,
        'userId': data?.email_id,
        "subscription_plan": data?.subscription_plan || editClientData?.subscription_plan,
        "usermenuList": menuList || [],
        "productInfo": systemData,
        "defaultProduct": data?.defaultproduct
      };
      const response = await axios.patch(userauthregisterurl, Payload, {
        headers: {
          "Content-Type": "application/json",
          'tymeplusjwt': token
        },
        mode: "cors",
      });

      if (
        response.status === 200 ||
        response.status === 201 ||
        response?.data?.status === 201 ||
        response?.data?.status === 200 ||
        response?.data?.statusCode === 201 ||
        response?.data?.statusCode === 200
      ) {
        console.log("response enter--->", response)
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      // message.error(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

  const handleSubmitEditForm = async () => {
    setLoading(true);
    // handlesubmit();
    const systemData = {
      tymeplusHrStatus: data?.products?.tymeplusHrStatus ? true : false,
      tymeplusPayStatus: data?.products?.tymeplusPayStatus ? true : false,
    };
    const url =
      "https://gwshc8kn48.execute-api.ap-southeast-1.amazonaws.com/Prod/updateData";
    // const url =
    //   "https://nhay2hvx12.execute-api.ap-northeast-1.amazonaws.com/Prod/updateData";
    const obj = {
      client_name: data?.client_name || editClientData?.client_name,
      system_name: data?.Support || editClientData?.Support,
      basic_plan: data?.basic_plan || editClientData?.basic_plan,
      advanced_plan: data?.advanced_plan || editClientData?.advanced_plan,
      enterprise_plan: data?.enterprise_plan || editClientData?.enterprise_plan,
      status: data?.status || editClientData?.status,
      updated_date: new Date().toLocaleDateString("en-CA"),
      created_date: new Date().toLocaleDateString("en-CA"),
      updated_by: "",
      created_by: "",
      location: data?.location || editClientData?.location,
      email_id: data?.email_id || editClientData?.email_id,
      employee_count: data?.employee_count || editClientData?.employee_count,
      subscription_plan:
        data?.subscription_plan || editClientData?.subscription_plan,
      contact_person: data?.contact_person || editClientData?.contact_person,
      contact_number: data?.contact_number || editClientData?.contact_number,
      company_name: data?.company_name || editClientData?.company_name,
      password: data?.password || editClientData?.password,
      amount: data?.amount || editClientData?.amount,
      discount: data?.discount || editClientData?.discount,
      subscriber_count:
        data?.subscriber_count || editClientData?.subscriber_count,
      supscription_frequency:
        data?.supscription_frequency || editClientData?.supscription_frequency,
      clientid: userDetails?.clientId,
      usermenulist: menuList,
      products: systemData || editClientData?.system,
      defaultproduct: data.defaultproduct,
      subscription_start_date: data?.subscription_start_date || editClientData?.subscription_start_date,
    };
    console.log("obj---->", obj)
    try {
      const response = await axios.patch(`${url}/${editClientData?.id}`, obj, {
          headers: {
            "tymeplusjwt": token
          }
        }
      );
      if (
        response?.data?.status === 201 ||
        response?.data?.status === 200 ||
        response?.data?.statusCode === 201 ||
        response?.data?.statusCode === 200
      ) {
        setLoading(false);
        const newData = response.data.response;
        const updatedData = getAllClientData?.map((item) =>
          item.id === editClientData?.id ? { ...item, ...newData } : item
        );
        dispatch(setGetAllClientData(updatedData));
        message.success("Edited successfully!");
        navigate("/client");
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      setLoading(false);
      message.error("Failed to edit. Please try again.");
    }
  };

  const columns1 = [
    {
      title: "Feauture Name",
      dataIndex: "clientName",
      key: "clientName",
    },
    // {
    //   title: "Pricing",
    //   dataIndex: "pricing",
    //   key: "pricing",
    //   render: (text) => (text === "" ? "--" : text),
    // },
    {
      title: "Available In",
      dataIndex: "availableIn",
      key: "availableIn",
    },
    {
      title: "Access",
      dataIndex: "access",
      key: "access",
      render: (text, record) => (
        <Switch
          className="switch_button"
          defaultChecked
          name={record.clientName}
          size="small"
          checked={record.access}
          onChange={(checked) => handleSwitchChange(record, checked)}
        />
      ),
    },
  ];

  const items = [
    {
      key: "1",
      label: "Basic",
      children: "",
    },
    {
      key: "2",
      label: "Features",
      children: "",
    },
  ];

  const onChangeTabs = (key) => {
    if (key === "1") {
      setStep(1);
    } else if (key === "2") {
      setStep(2);
    }
  };
  const groupedData = {
    Basic: menuList?.filter(
      (item) =>
        item?.system === "hr" &&
        (item?.key === "allapprovals" || item?.planType === "Basic")
    ),
    Lite: menuList?.filter(
      (item) =>
        item?.system === "hr" &&
        (item?.key === "allapprovals" || item?.planType === "Lite")
    ),
    Pro: menuList?.filter(
      (item) =>
        item?.system === "hr" &&
        (item?.key === "allapprovals" || item?.planType === "Pro")
    ),
  };

  const groupedPayData = {
    Basic: menuList?.filter(
      (item) => item?.system === "pay" && item?.planType === "Basic" && item
    ),
    Lite: menuList?.filter(
      (item) => item?.system === "pay" && item?.planType === "Lite" && item
    ),
    Pro: menuList?.filter(
      (item) => item?.system === "pay" && item?.planType === "Pro"
    ),
  };

  return (
    <StyledClientWrapper>
      {ispermission ? (
        <>
          <label
            className="bg-transparent border-0 mb-3 text-left styled-cursor"
            onClick={() => setIsPermission(false)}
          ></label>{" "}
          <b className="pb-0 pt-1">Select Permission</b>
          <UITable data={tabledata} columns={columns} />
          <div className="text-right w-100 p-1">
            <ButtonFilled
              className="text-end"
              type="primary"
              onClick={() => setIsPermission(true)}
            >
              Create
            </ButtonFilled>
          </div>
        </>
      ) : (
        <>
          <div>
            <div>
              <h5 className="view_client_goback">
                <p onClick={() => navigate("/client")}>Client</p>{" "}
                <RightOutlined className="right_out_icon" />{" "}
                <storng>Editing Client</storng>{" "}
              </h5>
            </div>
            {/* <StepsProgress stepdata={stepdata} title="Add Role:" step={step} /> */}
            {/* <div>
                <Tabs defaultActiveKey="1" items={items} onChange={onChangeTabs} />
            </div> */}
            {step === 1 && (
              <>
                <GridBuilder
                  formStructureJson={addNewClientForm}
                  formSubmit={handleSubmitEditForm}
                  handleChange={handleFormChange}
                  handleSelectChange={handleSelectChange}
                  handleBack={handleClickCancel}
                  initialValues={data}
                  setData={setData}
                />
              </>
            )}
            <br />
            <br />
            {step === 1 && (
              <>
                {/* <StyledTable
                  dataSource={clientPermissionData}
                  columns={columns1}
                  rowClassName={() => "custom-row"}
                  pagination={false}
                /> */}
                {data?.products && data?.products.tymeplusHrStatus && (
                  <>
                    <p className="system_label">Tymeplus HR Features</p>
                    <div style={{ display: "flex", gap: "20px" }}>
                      {Object.entries(groupedData)?.map(([planType, data]) =>
                        renderPlanBox(planType, data)
                      )}
                    </div>
                  </>
                )}
                {data?.products && data?.products.tymeplusPayStatus && (
                  <>
                    <p className="system_label">Tymeplus Pay Features</p>
                    <div style={{ display: "flex", gap: "20px" }}>
                      {Object.entries(groupedPayData)?.map(([planType, data]) =>
                        renderPlanBox(planType, data)
                      )}
                    </div>
                  </>
                )}

                <div className="text-right w-100 form_button_section">
                  {/* <Button className="text-end" onClick={() => setStep(1)}>
                    Back
                  </Button> */}
                  <ButtonOutlined
                    className="text-end"
                    // type="primary"
                    // disabled={loading}
                    onClick={() => navigate("/client")}
                  >
                    Cancel
                  </ButtonOutlined>
                  <ButtonFilled
                    className="text-end"
                    type="primary"
                    disabled={loading}
                    onClick={handleSubmitEditForm}
                  >
                    {loading ? <Spin /> : "Save"}
                  </ButtonFilled>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </StyledClientWrapper>
  );
};

export default EditClient;
